import React from "react";
import { useNavigate } from "react-router-dom";

const Newsletter = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <main className="container mx-auto p-6">
        <section className="mb-8 overflow-hidden rounded-3xl bg-gradient-to-r from-slate-900 via-slate-800 to-violet-900 text-white shadow-sm">
          <div className="p-8 md:p-10">
            <p className="mb-3 inline-flex rounded-full bg-white/10 px-3 py-1 text-sm font-medium text-blue-100">
              Dashboard Newsletter
            </p>

            <h1 className="mb-3 text-3xl font-bold md:text-4xl">
              Newsletter
            </h1>

            <p className="max-w-2xl text-sm leading-7 text-slate-200 md:text-base">
              Gérez vos abonnés et choisissez le type de communication à envoyer
              : un mail libre ou le partage d’un nouveau post.
            </p>
          </div>
        </section>

        <section className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm transition hover:shadow-md">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-500/15 text-2xl">
              📩
            </div>

            <h2 className="mb-2 text-xl font-semibold text-white">
              Voir les abonnés
            </h2>

            <p className="mb-6 text-slate-400">
              Consultez la liste des inscrits à la newsletter, recherchez une
              adresse email et suivez l’état des abonnements.
            </p>

            <button
              onClick={() => navigate("/dashboard/newsletter/subscribers")}
              className="rounded-xl bg-violet-600 px-5 py-3 font-semibold text-white transition hover:bg-violet-500"
            >
              Ouvrir la liste
            </button>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm transition hover:shadow-md">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-500/15 text-2xl">
              ✉️
            </div>

            <h2 className="mb-2 text-xl font-semibold text-white">
              Envoyer un mail libre
            </h2>

            <p className="mb-6 text-slate-400">
              Rédigez un message personnalisé à destination des abonnés actifs,
              avec un sujet et un contenu entièrement libres.
            </p>

            <button
              onClick={() => navigate("/dashboard/newsletter/create")}
              className="rounded-xl bg-green-500 px-5 py-3 font-semibold text-white transition hover:bg-green-600"
            >
              Créer un mail libre
            </button>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm transition hover:shadow-md">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/15 text-2xl">
              📰
            </div>

            <h2 className="mb-2 text-xl font-semibold text-white">
              Partager un nouveau post
            </h2>

            <p className="mb-6 text-slate-400">
              Sélectionnez un article existant pour générer un envoi dédié et
              informer vos abonnés qu’un nouveau contenu est disponible.
            </p>

            <button
              onClick={() => navigate("/dashboard/newsletter/share-post")}
              className="rounded-xl bg-amber-500 px-5 py-3 font-semibold text-slate-950 transition hover:bg-amber-600"
            >
              Partager un post
            </button>
          </div>
        </section>

        <section className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm">
          <h2 className="mb-3 text-lg font-semibold text-white">
            À propos de ce module
          </h2>

          <p className="leading-7 text-slate-400">
            Cette section centralise la gestion de la newsletter du site :
            consultation des abonnés, envoi de mails libres et partage manuel de
            nouveaux posts. Cette approche permet de garder le contrôle sur les
            communications envoyées tout en préparant une structure plus claire
            et évolutive pour la suite du projet.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Newsletter;